import { documentDefinition } from '../types/Search';

const generateFileNameExport = (data: documentDefinition) => {
    const uniqueAttributeNames = data?.attributes
        .filter((attr) => attr.displayOrder != '-1')
        .sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1))
        .map((att) => att.name)
        .filter((value, index, self) => self.indexOf(value) === index);
    const uniqueDescriptors = data?.attributes
        .filter((attr) => attr.isDescriptor == true)
        .sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1))
        .map((att) => att.name)
        .filter((value, index, self) => self.indexOf(value) === index);

    let numberOfResultsToUse = uniqueDescriptors.length > 4 ? uniqueDescriptors.length : 4;

    const fieldsToUse = uniqueAttributeNames.slice(0, numberOfResultsToUse);

    const fieldValues =
        fieldsToUse
            .map((field) => {
                const thisFieldsValues = data?.attributes
                    .filter((attr) => attr.name == field)
                    .sort((a, b) => (a.value > b.value ? 1 : -1));
                return thisFieldsValues.length > 0 ? thisFieldsValues[0].value : '';
            })
            .join('-') ?? '';
    const generatedFileName = `${data?.county}_${data?.state}_${data?.imageSubTypeAbbreviation}_${fieldValues}`;
    const removeSpaces = generatedFileName.replace(/ /g, '_');
    const removeBadCharacters = removeSpaces.replace(/[#%<>$!+`&*'|{}?"=/:@]/g, '');
    const removeBackSlash = removeBadCharacters.replace(/\\/g, '');
    return removeBackSlash;
};
const generateFileName = (data: documentDefinition) => {
    const uniqueAttributeNames = data?.attributes
        .filter((attr) => attr.displayOrder != '-1')
        .sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1))
        .map((att) => att.name)
        .filter((value, index, self) => self.indexOf(value) === index);
    const uniqueDescriptors = data?.attributes
        .filter((attr) => attr.isDescriptor == true)
        .sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1))
        .map((att) => att.name)
        .filter((value, index, self) => self.indexOf(value) === index);

    let numberOfResultsToUse = uniqueDescriptors.length > 4 ? uniqueDescriptors.length : 4;

    const fieldsToUse = uniqueAttributeNames.slice(0, numberOfResultsToUse);

    const fieldValues =
        fieldsToUse
            .map((field) => {
                const thisFieldsValues = data?.attributes
                    .filter((attr) => attr.name == field)
                    .sort((a, b) => (a.value > b.value ? 1 : -1));
                return thisFieldsValues.length > 0 ? thisFieldsValues[0].value : '';
            })
            .join('-') ?? '';

    const generatedFileName = `${data?.county} ${data?.state} ${data?.imageSubTypeAbbreviation} ${fieldValues}`;
    return generatedFileName;
};

export default {
    generateFileName,
    generateFileNameExport,
};
